import {Divider} from '~library/atoms/Divider';
import {Typography} from '~library/atoms/Typography';
import {useIsLargeAndUp} from '~library/hooks/useMatchQuery';
import {MOBILE_VIEWS, ResponsivePanel} from '~library/organisms/ResponsivePanel';

interface PollGuest {
  // biome-ignore lint/style/useNamingConvention: existing error
  guest_id: string;
  // biome-ignore lint/style/useNamingConvention: existing error
  guest_name: string;
}

interface PollChoiceOverlayProps {
  open: boolean;
  onClose: () => void;
  choice: string;
  guests?: PollGuest[];
}

export const PollChoiceOverlay = ({open, onClose, choice, guests = []}: PollChoiceOverlayProps) => {
  const isLargeAndUp = useIsLargeAndUp();

  const generateGuestInitials = (guest: PollGuest): string => {
    if (guest?.guest_name.indexOf(' ') >= 0) {
      return guest?.guest_name
        .replace(/[^a-zA-Z ]/g, '')
        .split(' ')
        .map((word) => word[0])
        .join('')
        .slice(0, 2)
        .toUpperCase();
    }
    return (
      guest?.guest_name
        .match(/[a-zA-Z]/)
        ?.pop()
        ?.toUpperCase() || ''
    );
  };

  return (
    <ResponsivePanel
      title={`${choice} (${guests.length})`}
      isOpen={open}
      portalMode={true}
      onClose={onClose}
      showCover={true}
      renderMobileViewAs={MOBILE_VIEWS.BOTTOM_SHEET}
    >
      {isLargeAndUp && <Divider />}
      <div>
        {guests?.map((guest) => (
          <div
            key={guest?.guest_id}
            className="poll-choice-slideout__guest"
            data-qa-id="settings-overlay__poll-list__guest"
          >
            <div className="poll-choice-slideout__guest-initials">
              {generateGuestInitials(guest)}
            </div>
            <Typography variant="paragraph2" data-qa-id="settings-overlay__poll-list__guest-name">
              {guest?.guest_name || ''}
            </Typography>
          </div>
        ))}
      </div>
    </ResponsivePanel>
  );
};
